import { useHandler } from '@surglogs-app/hooks'

import type { AnalyticsServiceCaptureEventData } from './types'
import { useEventCapture } from './useEventCapture'

export const useCaptureDialogToggleEvent = () => {
  const { captureEvent } = useEventCapture()

  const captureDialogToggleEvent = useHandler(
    async (
      toggleAction: 'open' | 'close',
      data: Omit<
        AnalyticsServiceCaptureEventData<'dialog_toggled'>,
        'toggle_action'
      >,
    ) => {
      await captureEvent('dialog_toggled', {
        toggle_action: toggleAction,
        ...data,
      })
    },
  )

  return { captureDialogToggleEvent }
}
